/**
 * Created by Ella Ma on 03/26/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TileChooseConfig, TileChooseEventType } from './tile-choose-visualization.model';
import { DataEventType } from '../data-visualizations/data-visualizations.model';
import { Subscription } from 'rxjs';
import { BriefConfig } from '../../../../widgets/widgets.model';

@Component({
    selector: 'tam-tile-choose-visualization',
    templateUrl: './tile-choose-visualization.component.html',
    styleUrls: ['./tile-choose-visualization.component.scss']
})
export class TileChooseVisualizationComponent implements OnInit, OnDestroy {
    @Input() config: TileChooseConfig;

    dataVisualizationsConfig: BriefConfig = new BriefConfig();
    private _subscriptions: Array<Subscription> = [];

    constructor() { }

    ngOnInit() {
        this._subscriptions.push(
            this.dataVisualizationsConfig.feedbackSubject$.subscribe(item => {
                if (item.type === DataEventType.clickIcon) {
                    this.selectChart(item.payload);
                } else if (item.type === DataEventType.dblClickIcon) {
                    this.dblClickIcon();
                }
            })
        );

    }

    ngOnDestroy() {
        this._subscriptions.forEach(item => item.unsubscribe());
    }

    selectChart(value: number) {
        this.config.events$.next({ type: TileChooseEventType.tileTypeChange, payload: value });
    }

    dblClickIcon() {
        this.config.events$.next({ type: TileChooseEventType.tileDblClick });
    }
}
